<template>
    <div class="trippoictxmenu-container" >
        <vs-button size="large" block transparent @click="callback('edit')">
            <img src="../../assets/icons/ctx/edit.png" style="width: 17px; height: 17px;" />{{ $t('common.edit') }}
        </vs-button>
        <vs-button size="large" block transparent @click="callback('delete')">
            <img src="../../assets/icons/ctx/delete.png" style="width: 17px; height: 17px;" />{{ $t('common.delete') }}
        </vs-button>
    </div>
    </template>
    
    <script>
    export default {
        name: 'tripPoiCtxMenu',
        props: {
            callback: Function
        }
    }
    </script>
    
    <style scoped>
    .trippoictxmenu-container {
        display: flex;
        flex-direction: column;
        background: #ECEBED;
        border-radius: 14px;
        overflow: hidden;
        z-index: 2500;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
    }
    </style><style>
    .trippoictxmenu-container .vs-button__content {
        justify-content: flex-start;
        align-items: center;
        font-weight: 600!important;
    }

    .trippoictxmenu-container .vs-button:nth-child(2) {
        color: var(--primary) !important;
    }
    </style>
    <style>
    .trippoictxmenu-container .vs-button {
        margin: 0;
        border-radius: 0!important;
        box-shadow: inset 0px -1px 0px rgba(208, 201, 214, 0.4);
    }
    
    </style>